module.exports = __webpack_public_path__ + "img/lockio-gold.27406165.svg";